import { Component } from '@angular/core';
import { EnumScales } from '@library/store/measures/measures.interface';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { getMonthText } from '@pages/control-page/control-page-main/control-page-reports/control-page-reports.service';
import { EnergyReportsFacade } from '@store/energy-reports/energy-reports.facade';
import { EnergyReport } from '@store/energy-reports/energy-reports.interface';
import { combineLatest, map } from 'rxjs';
import { CpReportsScaleService } from '../cp-reports-scale-selector/cp-reports-scale.service';

@Component({
  selector: 'app-cp-report-months',
  templateUrl: './cp-report-months.component.html',
  styleUrls: ['./cp-report-months.component.scss']
})
export class CpReportMonthsComponent {

  report$ = this.energyReportsFacade.currentReport$.pipe(isDefined());

  previousHours$ =
    combineLatest([
      this.report$,
      this.cpReportsScaleService.scale$
    ]).pipe(
      map(([report, scale]) => {
        if (scale === EnumScales.YEAR) {
          return typeof report.total_heating_time_previous_year !== 'undefined'? Math.round(report.total_heating_time_previous_year / 3600): null;
        }
        else {
          return typeof report.total_heating_time_previous_month !== 'undefined' ? Math.round(report.total_heating_time_previous_month / 3600): null;
        }

      })
    );

  currentHours$ = this.report$.pipe(
    map(report =>  typeof report.total_heating_time !== 'undefined' ? Math.round(report.total_heating_time / 3600) : null)
  );

  viewModel$ = combineLatest({
    report: this.report$,
    currentHours: this.currentHours$,
    previousHours: this.previousHours$,
    scale: this.cpReportsScaleService.scale$,
  });

  constructor(
    private energyReportsFacade: EnergyReportsFacade,
    private cpReportsScaleService: CpReportsScaleService,
  ) { }

  getPreviousMonthHeight(report: EnergyReport, scale: EnumScales) {
    let heatingTime = null;
    if (scale === EnumScales.YEAR) {
      heatingTime = report.total_heating_time_previous_year;
    }
    else {
      heatingTime = report.total_heating_time_previous_month;
    }
    if (!report) {
      return '4%';
    }
    if (heatingTime < 3600) {

      return '4%';
    }
    const heatinTimeCurrentMonth = Math.round(report.total_heating_time / 3600);
    const heatinTimePreviousMonth = Math.round(heatingTime / 3600);
    if (heatinTimePreviousMonth >= heatinTimeCurrentMonth) {
      if (heatingTime > 100 * 3600) {
        return '100%';
      }

      return '80%';
    }
    return heatingTime ? ((heatingTime / report.total_heating_time) * 100) * 0.8 + '%' : '4%';
  }

  getCurrentMonthHeight(report: EnergyReport, scale: EnumScales) {
    let heatingTimePrevious = null;
    if (scale === EnumScales.YEAR) {
      heatingTimePrevious = report.total_heating_time_previous_year;
    }
    else {
      heatingTimePrevious = report.total_heating_time_previous_month;
    }
    if (report == null ) {
      return '4%';
    }
    if (report.total_heating_time < 3600) {
      return '4%';
    }
    const heatinTimeCurrentMonth = Math.round(report.total_heating_time / 3600);
    const heatinTimePreviousMonth = Math.round(heatingTimePrevious / 3600);
    if (heatinTimeCurrentMonth >= heatinTimePreviousMonth) {
      if (report.total_heating_time > 100 * 3600) {
        return '100%';
      }
      return '80%';
    }
    return report.total_heating_time ? ((report.total_heating_time / heatingTimePrevious) * 100 * 0.8) + '%' : '4%';
  }

  getHeight(height: string) {
    return `calc(${height} + 32px)`;
  }

  hasNoData(houres: number) {
    return houres === null;
  }

  getPreviousMonthTextScale(report: EnergyReport, scale: EnumScales) {
    if (scale === EnumScales.YEAR) {
      return getMonthText(report.month , report.year - 1) + ' ' + (report.year - 1);
    }
    else {
      return getMonthText(report.month - 1, report.year);
    }
  }

  getMonthText(report: EnergyReport, scale: EnumScales) {
    if (scale === EnumScales.YEAR) {
      return getMonthText(report.month, report.year) + ' ' + report.year;
    }
    else {
      return getMonthText(report.month, report.year);
    }
  }
}
